import { useEffect, useRef, useState } from 'react';
import { LottieComponent, LottieComponentProps, UseLottieHook } from '../types/LottieComponent';

interface Props {
  InnerComponent: LottieComponent<LottieComponentProps>;
}

export const LottieWrapper = (props: Props): JSX.Element => {
  const useLottieLib = useRef<UseLottieHook>(() => ({ View: null }));
  const [loaded, setLoaded] = useState<boolean>(false);
  const { InnerComponent } = props;

  useEffect(() => {
    const loadLottie = async (): Promise<void> => {
      const { useLottie } = await import('lottie-react');
      useLottieLib.current = useLottie as unknown as UseLottieHook;
      setLoaded(true);
    };

    loadLottie();
  }, []);

  return (loaded ?
      <InnerComponent useLottie={useLottieLib.current} /> : <>&nbsp;</>
  )
};
